var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11537_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2359 1.7041C9.47505 1.7041 8.04836 3.3204 8.04836 5.31325C8.04836 3.31907 6.62167 1.7041 4.86085 1.7041C3.10003 1.7041 1.67334 3.3204 1.67334 5.31325C1.67334 8.39867 4.16872 11.382 8.04836 13.2263C11.9267 11.382 14.422 8.39867 14.422 5.31325C14.422 3.31907 12.9954 1.7041 11.2345 1.7041",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2359 1.7041C9.47505 1.7041 8.04836 3.3204 8.04836 5.31325C8.04836 3.31907 6.62167 1.7041 4.86085 1.7041C3.10003 1.7041 1.67334 3.3204 1.67334 5.31325C1.67334 8.39867 4.16872 11.382 8.04836 13.2263C11.9267 11.382 14.422 8.39867 14.422 5.31325C14.422 3.31907 12.9954 1.7041 11.2345 1.7041H11.2359Z",
    stroke: "#fff",
    strokeWidth: 1.855,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3915 1.63379C9.68641 1.63379 8.29817 3.23417 8.29817 5.20051H7.77709C7.77709 3.23417 6.39017 1.63379 4.68372 1.63379C2.97726 1.63379 1.59167 3.23417 1.59167 5.20051C1.59167 8.26338 4.05788 11.3594 8.03829 13.3019C12.0187 11.3594 14.4849 8.26338 14.4849 5.20051C14.4849 3.23417 13.0967 1.63379 11.3915 1.63379Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3915 1.63379C9.68641 1.63379 8.29817 3.23417 8.29817 5.20051H7.77709C7.77709 3.23417 6.39017 1.63379 4.68372 1.63379C2.97726 1.63379 1.59167 3.23417 1.59167 5.20051C1.59167 8.26338 4.05788 11.3594 8.03829 13.3019C12.0187 11.3594 14.4849 8.26338 14.4849 5.20051C14.4849 3.23417 13.0967 1.63379 11.3915 1.63379Z",
    stroke: "#CED4DA",
    strokeWidth: 0.521,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3683 7.1645C16.0437 7.07169 14.8849 8.20535 14.7801 9.69568C14.8849 8.20535 13.8944 6.92186 12.5698 6.82905C11.2452 6.73623 10.0864 7.86989 9.98163 9.36022C9.81987 11.6673 11.5436 14.0301 14.3664 15.6133C17.3829 14.4385 19.4182 12.3382 19.5786 10.0311C19.6834 8.54081 18.6929 7.25732 17.3683 7.1645Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3683 7.1645C16.0437 7.07169 14.8849 8.20535 14.7801 9.69568C14.8849 8.20535 13.8944 6.92186 12.5698 6.82905C11.2452 6.73623 10.0864 7.86989 9.98163 9.36022C9.81987 11.6673 11.5436 14.0301 14.3664 15.6133C17.3829 14.4385 19.4182 12.3382 19.5786 10.0311C19.6834 8.54081 18.6929 7.25732 17.3683 7.1645Z",
    stroke: "#fff",
    strokeWidth: 1.855,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5845 7.01414C16.2877 6.92397 15.1461 8.06957 15.0413 9.56786L14.5216 9.53206C14.6263 8.03377 13.6558 6.73967 12.359 6.64951C11.0623 6.55935 9.92064 7.70494 9.81589 9.20323C9.65148 11.5581 11.3831 14.0747 14.3439 15.7917C17.5142 14.5029 19.58 12.2528 19.7457 9.89801C19.8504 8.39972 18.8799 7.10563 17.5831 7.01546",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5845 7.01414C16.2877 6.92397 15.1461 8.06957 15.0413 9.56786L14.5216 9.53206C14.6263 8.03377 13.6558 6.73967 12.359 6.64951C11.0623 6.55935 9.92064 7.70494 9.81589 9.20323C9.65148 11.5581 11.3831 14.0747 14.3439 15.7917C17.5142 14.5029 19.58 12.2528 19.7457 9.89801C19.8504 8.39972 18.8799 7.10563 17.5831 7.01546L17.5845 7.01414Z",
    stroke: "#6C757D",
    strokeWidth: 0.521,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11537_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.752,
    height: 16.827,
    fill: "#fff",
    transform: "translate(.557 .586)"
  })))));
};
export default SvgHeart;